import {
    UPDATE_BUSINESSCATEGORY_FAILED,
    UPDATE_BUSINESSCATEGORY_LOADING,
    UPDATE_BUSINESSCATEGORY_SUCCESS,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status: null,
  };
  
  export const updateBusCatReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any, status:any }
  ) => {
    switch (action.type) {
      case UPDATE_BUSINESSCATEGORY_LOADING:
        return {
          ...state,
          loading:true,
          error: null,
          status: null,
        };
      case UPDATE_BUSINESSCATEGORY_SUCCESS:
        return {
          ...state,
          loading:false,
          status: action.status,
        };
      case UPDATE_BUSINESSCATEGORY_FAILED:
        return {
          ...state,
          loading:false,
          error: action.error,
          status: action.status,
        };
     
      default:
        return {
          loading: false,
          error: null,
          status: null,
        };
    }
  };
  